export const UPLOAD_RESOURCES_REQUEST = 'UPLOAD_RESOURCES_REQUEST';
